<template>
  <div class="add-game">
    <el-form
      :model="gameForm"
      :rules="gameRules"
      ref="gameForm"
      class="demo-gameForm"
      hide-required-asterisk
      label-position="left"
    >
      <el-form-item label="游戏封面：" prop="webGameCover">
        <upload-img
          :fixedNumber="[16, 16]"
          fixedName="16:16"
          accept="image/*"
          tip="只支持 16:16 尺寸"
          uploadName="上传封面"
          @uploadInfo="uploadInfo"
          :fixedFlag="true"
          fileDir="webgamecover"
          :resultImg="gameForm.webGameCover"
        />
      </el-form-item>
      <el-form-item label="游戏名称：" prop="webGameName">
        <el-input
          v-model="gameForm.webGameName"
          placeholder="请输入游戏名称"
          class="text-input"
        ></el-input>
      </el-form-item>
      <el-form-item label="游戏访问路径：" prop="webGameUrl">
        <el-input
          v-model="gameForm.webGameUrl"
          placeholder="请输入游戏访问路径"
          class="text-input"
        ></el-input>
      </el-form-item>
      <el-form-item label="游戏类型：" prop="webGameType">
        <el-select v-model="gameForm.webGameType" placeholder="请选择游戏类型">
          <el-option
            v-for="item in getDictDatas(DICT_TYPE.WEB_GAME_TYPE)"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="屏幕方向：" prop="screenOrientation">
        <el-select
          v-model="gameForm.screenOrientation"
          placeholder="请选择屏幕方向"
        >
          <el-option
            v-for="item in getDictDatas(DICT_TYPE.SCREEN_ORIENTATION)"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="坐标点：" class="coordinate-box">
        <el-row class="title-row">
          <el-col :span="6">坐标名称</el-col>
          <el-col :span="6">x</el-col>
          <el-col :span="6">y</el-col>
          <el-col :span="6">操作</el-col>
        </el-row>
        <el-row
          v-for="(item, index) in gameForm.gameCoordinate"
          :key="index"
          class="item-box"
        >
          <el-col :span="6">
            <el-form-item>
              <el-input v-model="item.name" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item>
              <el-input v-model="item.x" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item>
              <el-input v-model="item.y" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="delete-coordinate">
            <span @click="deleteCoordinate(index)">删除</span>
          </el-col>
        </el-row>
        <div class="add-coordinate" @click="addCoordinate">
          <img src="../../../assets/coordinate.png" alt="" />
          <p>添加坐标</p>
        </div>
      </el-form-item>
      <el-form-item class="btn-box">
        <el-button
          type="primary"
          @click="submitForm('gameForm')"
          class="enter-btn save-btn"
          :loading="submitLoading"
          >确认创建</el-button
        >
        <el-button @click="resetForm('gameForm')" class="cancel-btn calloff-btn"
          >取消</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import UploadImg from "../../../components/UploadImg";
import { setWebGame, getWebGameItem } from "@/api/game";
export default {
  components: { UploadImg },
  data() {
    return {
      gameForm: {
        webGameName: "",
        webGameType: "",
        webGameCover: "",
        webGameUrl: "",
        screenOrientation: "",
        gameCoordinate: [
          {
            name: "",
            x: "",
            y: "",
          },
        ],
      },
      gameRules: {
        webGameCover: [
          { required: true, message: "请上传游戏封面", trigger: "change" },
        ],
        webGameName: [
          { required: true, message: "请输入游戏名称", trigger: "blur" },
        ],
        webGameUrl: [
          { required: true, message: "请输入游戏访问路径", trigger: "blur" },
        ],
        webGameType: [
          { required: true, message: "请选择游戏类型", trigger: "change" },
        ],
        screenOrientation: [
          { required: true, message: "请选择屏幕方向", trigger: "change" },
        ],
      },
      submitLoading: false,
      type: "add",
      id: "",
    };
  },
  async created() {
    this.type = this.$route.query.type;
    if (this.type === "edit") {
      this.id = this.$route.query.id;
      const res = await getWebGameItem({ id: this.id });
      this.gameForm = res.result;
      // this.gameForm.gameCoordinate = JSON.parse(res.result.coordinate);
      this.$set(
        this.gameForm,
        "gameCoordinate",
        JSON.parse(res.result.coordinate)
      );
      this.gameForm.screenOrientation = String(res.result.screenOrientation);
      this.gameForm.webGameType = String(res.result.webGameType);
    }
  },
  mounted() {},
  methods: {
    // 获取上传封面
    uploadInfo(info) {
      // console.log("info :>> ", info);
      this.gameForm.webGameCover = info;
    },
    // 添加坐标点
    addCoordinate() {
      // console.log(111, this.gameForm.gameCoordinate);
      this.gameForm.gameCoordinate.push({
        name: "",
        x: "",
        y: "",
      });
    },
    // 删除节奏点
    deleteCoordinate(index) {
      if (this.gameForm.gameCoordinate.length === 1) {
        return;
      }
      this.gameForm.gameCoordinate.splice(index, 1);
      // console.log("this.mu :>> ", this.gameForm.gameCoordinate);
    },
    // 新建或者修改游戏
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.submitLoading = true;
          // console.log("object :>> ", this.gameForm);
          // this.gameForm.totalScore = this.totalScore;
          this.gameForm.coordinate = JSON.stringify(
            this.gameForm.gameCoordinate
          );
          await setWebGame(this.gameForm);
          this.$message.success("编辑成功！");
          this.$router.go(-1);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm() {
      // this.$refs[formName].resetFields();
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.add-game {
  ::v-deep .el-form {
    .el-form-item__label {
      width: 100px;
      white-space: nowrap;
    }
    .text-input,
    .el-select {
      width: 300px;
    }
    .coordinate-box {
      display: flex;
      > .el-form-item__content {
        border: 1px solid rgb(211, 211, 211);
        padding: 10px;
        border-radius: 10px;
        .title-row {
          background: #fafafa;
          padding: 10px;
          color: rgba(0, 0, 0, 0.88);
          font-weight: bold;
          text-align: center;
        }
        .item-box {
          padding: 5px 10px;
          box-sizing: border-box;
          height: fit-content;
          .el-col-6 {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 45px;
          }
          .delete-coordinate {
            color: red;
            cursor: pointer;
          }
          .el-form-item {
            width: 90%;
            margin: 0 auto;
          }
        }
        .add-coordinate {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 10px 0 0;
          cursor: pointer;
          img {
            width: 20px;
            height: 20px;
          }
          p {
            font-weight: bold;
            color: #ff5d2f;
            margin-left: 6px;
          }
        }
      }
    }
    .btn-box {
      margin: 50px 0 0 100px;
    }
  }
}
</style>
